import React, { useEffect } from 'react';
import { Route, useHistory } from 'react-router-dom';

import { MainLoader } from '@/components/shared/MainLoader';
import { useAuth } from '@/hooks/useAuth/useAuth';
import PageNotFound from '@/pages/System/PageNotFound';
import { ROUTES } from '@/router';
import { BrowserStorageService } from '@/services/BrowserStorage';

import { Props } from './types';

export const PrivateRoute = (props: Props) => {
  const { isAuthenticated, userInfo, loading } = useAuth();
  const history = useHistory();
  const { location, blockAccess = false, ...routeProps } = props;

  useEffect(() => {
    const AuthOnlyRoutes = [ROUTES.Auth.SelectCompany];

    if (
      !loading &&
      !userInfo &&
      !isAuthenticated &&
      !AuthOnlyRoutes.includes(location?.pathname || '')
    ) {
      BrowserStorageService.postAuthRedirect.set();
      history.push(ROUTES.Auth.LogIn);
    }
  }, [history, isAuthenticated, loading, location?.pathname, userInfo]);

  if (loading) {
    return <MainLoader />;
  }

  if (blockAccess) {
    return <PageNotFound />;
  }

  return <Route {...routeProps} exact />;
};
